const state = {
  curPlatformType: sessionStorage.getItem('curPlatformType') ? sessionStorage.getItem('curPlatformType') : undefined
}

const mutations = {
  SET_CUR_PLATFORM_TYPE(state, curPlatformType) {
    sessionStorage.setItem('curPlatformType', curPlatformType)
    state.curPlatformType = curPlatformType
  }
}

// actions
const actions = {}

// actions
const getters = {
  getCurPlatformType: (state) => state.curPlatformType
}

export default {
  state,
  getters,
  actions,
  mutations
}
